// extracted by css-extract-rspack-plugin
export default {"professions":"Professions-module__professions--eVdf2"};